import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { CityModel } from '../models/city';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Injectable({
  providedIn: 'root'
})

export class CityProvider {

  city: CityModel[] = [];

  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    ) {
  }

  getCityList(): void {
    if (this.city.length == 0) {
      this.apiService.get(this.apiConfig.configGetCities).subscribe(
        (res: any) => {
          this.city = res.data.cities as CityModel[];
        }
      );
    }
  }

}
